import { Col, Row } from 'reactstrap';

import GoBackToListButton from '../../../components/buttons/GoBackToListButton';
import { PathsLayouts } from '../../../config/routes';
import { DetailBox } from '@octano/global-ui';
import { validate, format } from 'rut.js';
import { useTranslation } from 'react-i18next';

interface StudentTabsHeaderProps {
  name: string;
  id: string;
}

export default function StudentTabsHeader({
  name,
  id,
}: StudentTabsHeaderProps) {
  const { t } = useTranslation();
  const formattedId =
    id && validate(id) ? format(id, { dots: true }) : id || '-';
  return (
    <Row className="d-flex justify-content-between align-items-center mt-4">
      <Col xs={12} md={6} lg={3}>
        <GoBackToListButton path={PathsLayouts.studentFile} />
      </Col>
      <Col xs={12} md={6} lg={5}>
        <DetailBox
          columns={[
            {
              title: t('terms:student.single'),
              body: name,
              size: { xs: 12, md: 8 },
            },
            {
              title: t('common.forms.rut'),
              body: formattedId,
              size: { xs: 12, md: 4 },
            },
          ]}
        />
      </Col>
    </Row>
  );
}
